<template>
  <div ref="chatMessages" class="chat-messages">
    <div class="chat-messages-list">
      <div
        v-for="(message, index) in messages"
        :key="message.id"
        class="chat-messages-list-item"
      >
        <div
          v-if="index === 0 || moment(message.dateMessage).format('DD/MM/YYYY') !== moment(messages[index - 1].dateMessage).format('DD/MM/YYYY')"
          class="chat-messages-day"
        >
          <p>
            {{ moment(message.dateMessage).format('DD/MM/YYYY') }}
          </p>
        </div>
        <ChatMessage
          :to="message.to"
          :type="message.type"
          :message="message.message"
          :fileBase="message.fileBase"
          :mimeType="message.mimeType"
          :date="message.dateMessage"
          :sent="message.sent"
          :description="message.description"
          :reply="message.reply"
          :provider="provider"
          :identifierProvider="identifierProvider"
          :buttonReply='buttonReply'
          @reply="handleReply"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage.vue'

export default {
  name: 'ChatMessages',
  components: {
    ChatMessage
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    provider: {
      type: String
    },
    identifierProvider: {
      type: String
    },
    buttonReply: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    scrollToBottom () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight
        }, 10)
      })
    },
    handleReply ({message, to}) {
      this.$emit('reply', {message, to})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/chat/ChatMessages.vue